import React, {useState, useEffect, useContext} from "react";
import { getReproductionsByUser } from "../../../api/reproductionApi";
import CroissanceWheel from "./CroissanceWheel";
import { changeReproductionStatusE } from "../../../api/reproductionApi";
import { AuthContext } from "../../../Contexts/AuthContext";

export const Croissance = () => {
    const {user} = useContext(AuthContext);
    const [reproductions, setReproductions] = useState([]);
    const idU = user.id;
  useEffect(() => {
    loadReproductions();
  }, []);

  const loadReproductions = () => {
    getReproductionsByUser(idU).then(res => setReproductions(res.data));
  };

  const handleStatusChange = async (id, newStatus) => {
  try {
    await changeReproductionStatusE(id, newStatus);

    const fresh = await getReproductionsByUser(idU);
    setReproductions(fresh.data);

  } catch (err) {
    console.error("Status change failed:", err);
    throw err;
  }
};

  return (
    <div>
      <CroissanceWheel reproductions={reproductions} onStatusChange={handleStatusChange} />
    </div>
  );
};